import dayjs from 'dayjs';

export const DISPLAY_DATE_FORMAT = 'MM/DD/YY';

const DEFAULT_INPUT_FORMATS = [
  'YYYY-MM-DD',
  'YYYY/MM/DD',
  'MM/DD/YYYY',
  'MM-DD-YYYY',
  'MM/DD/YY',
  'MM-DD-YY',
];

export const formatDisplayDate = (value, format = DISPLAY_DATE_FORMAT) => {
  if (!value) return '-';

  if (dayjs.isDayjs(value)) {
    return value.format(format);
  }

  const parsed = dayjs(value, DEFAULT_INPUT_FORMATS, true);
  if (parsed.isValid()) {
    return parsed.format(format);
  }

  const fallback = dayjs(value);
  return fallback.isValid() ? fallback.format(format) : value;
};
